import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Divider, Grid, Link, Paper, Table, TableBody, TableContainer, TableHead, TableRow, TextField, Typography, useTheme, } from "@mui/material";
import { FloppyDisk, Pencil, Plus, Trash } from "@phosphor-icons/react";
import { useEffect, useState, useContext } from "react";
import { StyledTableCell, StyledTableRow, TableRowsLoader, } from "../../components/mui-table/mui-table-helper";
import CompanyInfoModal from "./ContactPersonModal";
import LeadDetailApi from "../../../infrastructure/api/pages/lead-detail-api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import { checkCreateEdit, checkManage } from "../../../application/common/utils/roles-helper";
import { Modules } from "../../../application/common/enums/screen-name";
const initialFormData = {
    id: undefined,
    leadContactId: undefined,
    leadId: undefined,
    name: "",
    email: "",
    phoneNumber: "",
    function: "",
    isDeleted: false,
};
const ContactPersonTab = ({ setRefreshModalData, }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const leadId = urlParams.get("id");
    const theme = useTheme();
    const { t: translate } = useTranslation();
    const [notes, setNotes] = useState();
    const [contact, setContact] = useState(initialFormData);
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [noteSaving, setNoteSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [idToBeDeleted, setIdToBeDeleted] = useState();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    const columns = [
        { id: "sr", label: "#", minWidth: 30, align: "left" },
        { id: "name", label: "Name", minWidth: 150, align: "left" },
        {
            id: "function",
            label: "Function",
            minWidth: 150,
            align: "left",
        },
        {
            id: "phoneNumber",
            label: "PhoneNumber",
            minWidth: 150,
            align: "left",
        },
        {
            id: "email",
            label: "MailAddress",
            minWidth: 150,
            align: "left",
        },
        {
            id: "activities",
            label: "Activities",
            minWidth: 100,
            align: "left",
        },
    ];
    const [modalOpen, setModalOpen] = useState(false);
    const handleOpenModal = () => {
        setContact(initialFormData);
        setModalOpen(true);
    };
    const handleCloseModal = () => {
        setModalOpen(false);
    };
    useEffect(() => {
        GetLeadGeneralNotes();
        GetLeadContacts();
    }, []);
    useEffect(() => {
        setRefreshModalData((prev) => !prev);
    }, [contacts]);
    const GetLeadContacts = () => {
        if (leadId) {
            setLoading(true);
            LeadDetailApi.getLeadContacts(leadId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setContacts(response.data);
                }
            })
                .finally(() => {
                setLoading(false);
            });
        }
    };
    const GetLeadGeneralNotes = () => {
        if (leadId) {
            LeadDetailApi.getGeneralNotes(leadId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setNotes(response.data);
                }
            })
                .finally(() => { });
        }
    };
    const handleNotesChange = (event) => {
        setNotes(event.target.value);
    };
    const handleSaveNotes = () => {
        if (leadId) {
            setNoteSaving(true);
            const leadData = {
                id: leadId,
                generalNotes: notes !== null && notes !== void 0 ? notes : "",
            };
            LeadDetailApi.updateGeneralNotes(leadData)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    toast.success(translate("SavedSuccessfully"));
                }
            })
                .finally(() => {
                setNoteSaving(false);
            });
        }
    };
    const handleEditContact = (leadContactId) => {
        if (leadContactId) {
            LeadDetailApi.getContactById(leadContactId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setContact(response.data);
                    setModalOpen(true);
                }
            })
                .finally(() => { });
        }
    };
    const handleDeleteContact = (leadContactId) => {
        if (leadContactId) {
            setIdToBeDeleted(leadContactId);
            setDeleting(true);
            LeadDetailApi.deleteContact(leadContactId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    toast.success(translate("DeletedSuccessfully"));
                    GetLeadContacts();
                }
            })
                .finally(() => {
                setDeleting(false);
                setIdToBeDeleted(undefined);
            });
        }
    };
    const handlePhoneNumberClick = (phoneNumber) => {
        window.open(`tel:${phoneNumber}`);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                    padding: "var(--2, 16px) var(--4, 32px)"
                }, children: _jsxs(Grid, { container: true, sx: {
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }, children: [_jsx(Typography, { variant: "h2", children: translate("ContactPerson") }), checkCreateEdit(RolesPermissions, Modules.Leads) && (_jsx(Button, { type: "submit", variant: "outlined", sx: {
                                borderRadius: "12px",
                                border: "var(--none, 1px) solid var(--n-primary, #130922)",
                                background: "var(--n-primary-light, #F9F6FF)",
                                display: "flex",
                                padding: "12px !important",
                                alignItems: "flex-start",
                                gap: "10px",
                                minWidth: "auto !important",
                            }, onClick: handleOpenModal, children: _jsx(Plus, { size: 24 }) }))] }) }), _jsxs(Box, { sx: {
                    marginTop: "1%",
                    padding: "16px 32px",
                    bgcolor: theme.palette.common.white,
                    borderRadius: "24px",
                    maxHeight: "calc(100vh - 400px)",
                    overflow: "auto",
                }, children: [_jsx(Paper, { sx: { width: "100%", overflow: "hidden", boxShadow: "none" }, children: _jsx(TableContainer, { children: _jsxs(Table, { stickyHeader: true, "aria-label": "sticky table", children: [_jsx(TableHead, { children: _jsx(TableRow, { sx: { backgroundColor: theme.palette.common.white }, children: columns.map((column) => (_jsx(StyledTableCell, { align: column.align, style: { minWidth: column.minWidth }, children: _jsx(Typography, { variant: "h4", sx: { color: theme.palette.text.primary }, children: translate(`${column.label}`) }) }, column.id))) }) }), _jsx(TableBody, { children: loading ? (_jsx(TableRowsLoader, { rowsNum: 10, cellNum: 7 })) : (contacts.map((contact, index) => (_jsxs(StyledTableRow, { children: [_jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: index + 1 }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: contact.name }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: contact.function }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Link, { className: "card-body-text", style: { cursor: "pointer" }, onClick: () => handlePhoneNumberClick(contact.phoneNumber), target: "_blank", rel: "noreferrer", children: contact.phoneNumber }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Link, { href: `mailto:${contact.email}`, target: "_blank", rel: "noreferrer", children: contact.email }) }), _jsx(StyledTableCell, { align: "left", children: _jsxs(Grid, { container: true, sx: {
                                                            alignContent: "center",
                                                            justifyContent: "center"
                                                        }, children: [checkCreateEdit(RolesPermissions, Modules.Leads) && (_jsx(Grid, { size: 6, children: _jsx(Box, { sx: {
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        bgcolor: "#F4FCFF",
                                                                        borderRadius: "50%",
                                                                        width: "36px",
                                                                        height: "36px",
                                                                    }, children: _jsx(Pencil, { onClick: () => {
                                                                            handleEditContact(contact.leadContactId);
                                                                        } }) }) })), checkManage(RolesPermissions, Modules.Leads) && (_jsx(Grid, { size: 6, children: _jsx(Box, { sx: {
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        bgcolor: "#F4FCFF",
                                                                        borderRadius: "50%",
                                                                        width: "36px",
                                                                        height: "36px",
                                                                    }, children: deleting && idToBeDeleted == contact.leadContactId ? (_jsx(CircularProgress, { size: 24, color: "inherit" })) : (_jsx(Trash, { onClick: () => handleDeleteContact(contact.leadContactId) })) }) }))] }) })] }, contact.leadContactId || contact.id)))) })] }) }) }), _jsx(Divider, {}), checkCreateEdit(RolesPermissions, Modules.Leads) && (_jsx(Box, { sx: {
                            padding: "var(--2, 16px) var(--4, 0px)"
                        }, children: _jsx(Grid, { container: true, sx: {
                                justifyContent: "flex-end",
                                flexDirection: "row",
                                alignItems: "center"
                            }, children: _jsxs(Button, { type: "button", variant: "outlined", sx: {
                                    borderRadius: "12px",
                                    border: "var(--none, 1px) solid var(--n-primary, #130922)",
                                    background: "var(--n-primary-light, #F9F6FF)",
                                    display: "flex",
                                    padding: "12px !important",
                                    alignItems: "flex-end",
                                    gap: "10px",
                                    minWidth: "auto !important",
                                }, onClick: handleSaveNotes, disabled: notes == undefined || notes.trim() == "", children: ["Opslaan", noteSaving ? (_jsx(CircularProgress, { size: 24, color: "inherit" })) : (_jsx(FloppyDisk, { size: 24 }))] }) }) })), _jsx(TextField, { label: translate("GeneralNotes"), variant: "outlined", margin: "normal", rows: 3, defaultValue: notes, multiline: true, fullWidth: true, onChange: handleNotesChange })] }), _jsx(CompanyInfoModal, { open: modalOpen, onClose: handleCloseModal, GetLeadContacts: GetLeadContacts, initialFormData: initialFormData, data: contact })] }));
};
export default ContactPersonTab;
